import urlHelper from '@/helpers/urlHelper';
import router from '@/router';

export default {
  computed: {
    configuratorLogin() {
      return urlHelper.getConfiguratorHost() + '/project?login=true';
    },
    configuratorHref() {
      return urlHelper.getConfiguratorHost();
    }
  },
  methods: {
    //#region : GTAG Handling :
    handleBuildSystemClick(system) {
      // eslint-disable-next-line
      gtag('event', 'build_your_system');
    },
    handlePhoneClick() {
      // eslint-disable-next-line
      gtag('event', 'phone_click');
    },
    handleEmailClick() {
      // eslint-disable-next-line
      gtag('event', 'email_click');
    },
    //#endregion
    /**
     * Opens the system with the specified template ID.
     * @param {string} templateId - The ID of the template.
     */
    openSystem(templateId, data) {
      if (data && data.relativeUrl) {
        // determine which hard-coded event to call based on data
        if (data.relativeUrl.includes('/wirelessmicrophonesbasic')) {
          // eslint-disable-next-line
          gtag('event', 'wireless_mic_build');
        } else if (data.relativeUrl.includes('/venues/church')) {
          // eslint-disable-next-line
          gtag('event', 'church_build');
        } else if (data.relativeUrl.includes('/venues/podcast')) {
          // eslint-disable-next-line
          gtag('event', 'podcast_build');
        } else if (data.relativeUrl.includes('/drummicrophones')) {
          // eslint-disable-next-line
          gtag('event', 'drum_mic_build');
        } else if (data.relativeUrl.includes('/venues/theater')) {
          // eslint-disable-next-line
          gtag('event', 'theater_build');
        }
        // eslint-disable-next-line
        gtag('event', 'build_your_system');
      }
      window.location.href = `${this.configuratorHref}/project?projectTemplateId=${templateId}&landingPage=subsystem`;
    },
    /**
     * Replaces color markup in the given text with HTML span elements.
     *
     * @param {string} text - The text containing color markup.
     * @returns {string} The modified text with HTML span elements.
     */
    replaceColorMarkup(text) {
      if (!text) return '';
      return (
        '<span>' +
        text.replace(
          /\[(green|purple|blue|pink)\](.*?)\[\/\1\]/g,
          (match, color, content) => {
            return `<span class="${color}Text">${content}</span>`;
          }
        ) +
        '</span>'
      );
    },
    /**
     * Adds dynamic routes based on input routeData
     * @param {*} routeData
     */
    addDynamicRoutes(routeData) {
      if (!routeData) return;
      console.log(routeData);
      routeData.forEach((route) => {
        // venue routes are in format /venue/venueName
        // system routes are in format /venue/venueName/systemName
        const isVenue = route.relativeUrl.split('/').length - 1 == 2;
        const routeName = isVenue ? route.venue : route.system;
        const routeComponent = isVenue
          ? import('@/pages/VenueDetailsPage.vue')
          : import('@/pages/SystemDetailsPage.vue')
              .catch((error) =>
                console.error('Failed to load SystemDetailsPage:', error)
              )
              .finally(() => console.log('SystemDetailsPage loaded'));

        // Check for existing route
        const existingRoute = router.resolve({ name: routeName });
        if (existingRoute.route.matched.length > 0) {
          console.log('Route already exists: ', routeName);
          return;
        }

        try {
          router.addRoute({
            name: routeName,
            path: route.relativeUrl,
            component: () => routeComponent,
            props: { data: route }
          });
          console.log('Added route: ', routeName);
        } catch (error) {
          console.error('Failed to add route: ', routeName, error);
        }
      });
      // log list of route
      console.log('Routes: ', router.getRoutes());
    }
  }
};
